import React from "react"
import { useTranslation } from "react-i18next"

import { WithClassName } from "shared/types/WithClassName"

import { PriceTag } from "widgets/price-tag/PriceTag"

import { useProjectFormContext } from "../contexts/ProjectFormContext"

export interface ProjectFormPriceTotalProps extends WithClassName {}

export const ProjectFormPriceTotal = React.memo(
  ({ className }: ProjectFormPriceTotalProps) => {
    const { t } = useTranslation()
    const { model } = useProjectFormContext()

    const price = model?.pricing.data.price?.data
    const isLoading = model?.pricing.data.price?.isLoading
    const isUpdating = model?.pricing.data.price?.isUpdating

    return (
      <div
        className="project-form__price-groups"
        data-testid="project-price-total"
      >
        <PriceTag
          label={t("Price.ProjectTotalPrice")}
          price={price?.priceTotal}
          currency={price?.currency}
          isLoading={isLoading}
          isUpdating={isUpdating}
          className={className}
        />
      </div>
    )
  }
)

ProjectFormPriceTotal.displayName = "ProjectFormPriceTotal"
